import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import FormasPagamento from '../../formasPagamento/components/FormasPagamento.vue'
import CartaoPagamento from '../../formasPagamento/components/CartaoPagamento.vue'
import { faturaMixin } from '@/modules/faturas/mixins'
import { formasPagamentoMixins } from '@/modules/formasPagamento/mixins'

export default {
  name: 'pagamento',
  components: {
    spinnerProcessando,
    FormasPagamento,
    CartaoPagamento
  },
  mixins: [faturaMixin, formasPagamentoMixins],
  computed: {},
  data: () => {
    return {
      cartaoPadrao: false,
      isLoading: false,
      isLoadingCartao: false,
      cartoes: [],
      formulario: {},
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      bandeiraDoCartao: null,
      formasDePagamento: [],
      pagamentoSelecionado: '',
      listaDeErros: {}
    }
  },

  async mounted () {
    this.$parent.$on('lista-configuracao-fatura', (listaConfiguracaoFatura) => {
      this.formasDePagamento = listaConfiguracaoFatura.formas_pagamento
      // Ordena a lista 'formasDePagamento' para que 'Cartão de Crédito' apareça primeiro
      this.formasDePagamento = this.formasDePagamento.sort((a, b) => {
        if (a.nome === 'Cartão de crédito') return -1
        if (b.nome === 'Cartão de crédito') return 1
        return 0
      })

      if (listaConfiguracaoFatura.pagamento.length > 0) {
        this.atualizarFormaPagamento(this.formasDePagamento.filter(r => r.id === listaConfiguracaoFatura.pagamento)[0].nome)
      }
    })

    this.obterCartoes()
  },

  methods: {}
}
